/**
 * List of possible form input types.
 */
export enum InputType {
  PLAIN_TEXT,
  NUMBER,
  TOGGLE,
  SELECT,
  MULTI
}
